<template>
  <div>
    <span v-if="fireTermination">
      <svg :width="size" :height="size" viewBox="0 0 200 200" style="fill-rule:evenodd;clip-rule:evenodd;">
        <path :fill="getTheme.fire" d="M0,200l100,-200l100,200l-200,0Zm24.271,-15l151.458,0l-75.729,-151.459l-75.729,151.459Z"/>
      </svg>
    </span>
    <span v-if="airTermination">
      <svg :width="size" :height="size" viewBox="0 0 200 200" style="fill-rule:evenodd;clip-rule:evenodd;">
        <path :fill="getTheme.air" d="M146.25,92.5l34.75,0l0,15l-27.25,0l46.25,92.5l-200,0l46.25,-92.5l-27.25,0l0,-15l34.75,0l46.25,-92.5l46.25,92.5Zm-9.271,15l-73.958,0l-38.75,77.5l151.458,0l-38.75,-77.5Zm-66.458,-15l58.958,0l-29.479,-58.959l-29.479,58.959Z"/>
      </svg>
    </span>
    <span v-if="waterTermination">
      <svg :width="size" :height="size" viewBox="0 0 200 200" style="fill-rule:evenodd;clip-rule:evenodd;">
        <path :fill="getTheme.water" d="M0,0l100,200l100,-200l-200,0Zm24.271,15l75.729,151.459l75.729,-151.459l-151.458,0Z"/>
      </svg>
    </span>
    <span v-if="earthTermination">
      <svg :width="size" :height="size" viewBox="0 0 200 200" style="fill-rule:evenodd;clip-rule:evenodd;">
        <path :fill="getTheme.earth" d="M153.75,92.5l27.25,0l0,15l-34.75,0l-46.25,92.5l-46.25,-92.5l-34.75,0l0,-15l27.25,0l-46.25,-92.5l200,0l-46.25,92.5Zm-24.271,15l-58.958,0l29.479,58.959l29.479,-58.959Zm7.5,-15l38.75,-77.5l-151.458,0l38.75,77.5l73.958,0Z"/>
      </svg>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ViaPunctiShield',
  props: ['index'],
  computed: {
    ...mapGetters(['getTheme']),
    fireTermination () {
      if (this.$store.state.viaPunctiFire.length === 1) {
        return this.$store.state.viaPunctiFire[0].id === this.index
      }
      return false
    },
    airTermination () {
      if (this.$store.state.viaPunctiAir.length === 1) {
        return this.$store.state.viaPunctiAir[0].id === this.index
      }
      return false
    },
    waterTermination () {
      if (this.$store.state.viaPunctiWater.length === 1) {
        return this.$store.state.viaPunctiWater[0].id === this.index
      }
      return false
    },
    earthTermination () {
      if (this.$store.state.viaPunctiEarth.length === 1) {
        return this.$store.state.viaPunctiEarth[0].id === this.index
      }
      return false
    },
    size () {
      return '12px'
    }
  }
}
</script>

<style scoped>
div {
  position: absolute;
  top: -20px;
  width: 50px;
}
</style>
